export default function Main() {
     const sectionStyle = {
          backgroundImage: 'url("/images/yellow-flower-2.jpg")', // Reference to public folder
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          
          minHeight: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        };
     return(
          <main className = "main-section" style={sectionStyle}>
               <div className = "welcome-box">
               <h2 className = "welcome-message">
                    Welcome
               </h2>
               <p className = "welcome-text">
               Welcome to Alive Gardens, where your outdoor vision comes to life. We specialize in the restoration, alteration, and modernization of residential and commercial landscapes. By combining competitive pricing with meticulous craftsmanship, we create efficient, sustainable, and beautiful environments that keep our clients coming back season after season. Proudly serving the NYC area.
               </p>

               
               </div>
          </main>
     );
}